/** @fileoverview list_bigquery の共通定数 */

/** ツール名（単一参照点） */
export const LIST_BIGQUERY_NAME = "list_bigquery" as const;

/** LLM へ提示する説明文 */
export const LIST_BIGQUERY_DESC = `Lists all BigQuery configurations for a workspace (Organization), covering both Search Analytics (SA) and User Analytics (UA).

Use this when the user asks to see every configured BigQuery dataset/project for the workspace.

Input:
- 'organizationId' (required): The ID of the target workspace (Organization).

Notes:
- Read-only. Does not create, update, or delete anything.
- Returns two arrays: 'searchAnalyticsBigQueries' and 'userAnalyticsBigQueries'. SA rows may include manageType 'API'. Create API connections with 'create_search_analytics_bigquery' using manageType 'API' and propertyID. UA configs include event source, available/selected event parameter keys, and event-param backfill status.
- When no configuration exists for the target project kind, use 'create_user_analytics_bigquery' or 'create_search_analytics_bigquery' instead of asking the user to visit workspace settings.`;
